var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgMarketplaceIconActive(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.828 7.904l-1.953.075a6.799 6.799 0 00-.519-2.514 6.477 6.477 0 00-1.402-2.1A4.288 4.288 0 0012 2.131c-1.703 0-3.2 1.077-4.071 2.73a7.175 7.175 0 00-.804 3.118l-1.953-.075a9.775 9.775 0 01.416-2.546C6.554 2.21 9.05 0 12 0a6.222 6.222 0 012.928.782 6.646 6.646 0 012.282 2.097 9.204 9.204 0 011.618 5.025z",
    fill: "#8C5938"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 9.583v7.313c0 1.884-.706 3.691-1.962 5.023C18.782 23.252 17.08 24 15.303 24H8.697c-1.776 0-3.48-.748-4.735-2.08C2.706 20.586 2 18.78 2 16.895V9.583c0-.496.186-.972.516-1.322.33-.35.779-.548 1.246-.548h16.486c.466.003.911.202 1.24.552.328.35.512.824.512 1.318z",
    fill: "#D48757"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 7.717c0 5.904-2.577 13.31-13.624 13.31A7.35 7.35 0 012 16.898V9.582c0-.496.186-.972.516-1.322.33-.35.779-.548 1.246-.548l13.113.004z",
    fill: "#EEA064"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.89 9.916H6.113c-.517 0-.937.445-.937.994v.004c0 .55.42.994.938.994H17.89c.518 0 .938-.445.938-.994v-.004c0-.55-.42-.994-.938-.994zM17.89 13.497H6.113c-.517 0-.937.446-.937.995v.004c0 .549.42.994.938.994H17.89c.518 0 .938-.445.938-.994v-.004c0-.55-.42-.995-.938-.995z",
    fill: "#8C5938"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2)",
    d: "M0 0h20v24H0z"
  })))));
}
export default SvgMarketplaceIconActive;